import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=6244ae73"
import script from "./registration.vue?vue&type=script&lang=js"
export * from "./registration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/bonuses/registration.vue
// module id = rIV3
// module chunks = 0